import {Injectable} from '@angular/core';
import {ApiService} from '@common-lib';
import {map} from 'rxjs/operators';

@Injectable()
export class VariantEditService {
  constructor(private api: ApiService) {
  }

  getLocalizations() {
    return this.api.get(`/admin/localizations`).pipe(map(({result}) => result));
  }

  getProduct(id) {
    return this.api.get(`/admin/variant/${id}`).pipe(map(({result}) => result));
  }

  getImagesList(product) {
    return this.api.get(`/filemanager/files/?dir=assets/${product}/layers`).pipe(map(({result}) => result));
  }

  update(id, data) {
    return this.api.put(`/admin/variant/${id}`, data).pipe(map(({result}) => result));
  }

  save(data, localeName?: string) {
    const url = localeName ? `/admin/variant/${localeName}` : `/admin/variant`;
    return this.api.post(url, data).pipe(map(({result}) => result));
  }
}



// WEBPACK FOOTER //
// ./src/app/pages-services/variant-edit.service.ts